import type {TShow} from '../../../hooks/useShow';
import type {TXHR} from '../../../assets/constants/constansts.type';
import type {TemplateStructure} from '../../whatsAppTemplateEditor/types/templateStructure';

export type UserChatMessage = {role: 'user'; text: string};
export type AssistantChatMessage = {
    role: 'assistant';
    text: string;
    id?: string;
    parameterValues?: TemplateStructure;
};
export type ChatMessage = UserChatMessage | AssistantChatMessage;
export type AssistantDraftPayload = AssistantChatMessage;

export interface DraftResult {
    text: string;
    parameterValues?: TemplateStructure;
}

export type AISubmitHandler = (
    prompt: string,
    history: ChatMessage[],
    sessionId: string
) => Promise<DraftResult | null>;

export function mapChatMessagesToApiHistory(messages: ChatMessage[]): ChatMessage[] {
    return messages.map(message => {
        if(message.role === 'user') {
            return {role: 'user', text: message.text};
        }
        return {
            role: 'assistant',
            text: message.text,
            ...(message.parameterValues ? {parameterValues: message.parameterValues} : {}),
        };
    });
}

export interface AIMessageGeneratorProps {
    show: TShow;
    title: string;
    placeholder: string;
    submit: {
        label: string;
        onClick: AISubmitHandler;
        xhrState?: TXHR;
    };
    approve: {
        label: string;
        onClick: (draft: AssistantDraftPayload) => Promise<void>;
        xhrState?: TXHR;
    };
    errorMessage: string;
    suggestions: string[];
    analytics?: {
        contentId: string | number;
        sourceTypeId: string;
        context?: Record<string, unknown>;
    };
    container?: 'sidePopup' | 'innerPop';
}
